//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import ProcessCurrencyDrawer from "./modules/ProcessCurrencyDrawer";
import { JeecgListMixin } from '@/mixins/JeecgListMixin';
import { queryDepartTreeList, queryUserTreeList } from '@/api/api';
export default {
  name: 'ProcessCurrencyList',
  mixins: [JeecgListMixin],
  components: {
    ProcessCurrencyDrawer: ProcessCurrencyDrawer
  },
  data: function data() {
    return {
      pagePath: '/om/process/currency',
      pageTitle: '通用审批表单',
      deptTree: [],
      userTree: [],
      // 表头
      columns: [{
        title: '序号',
        dataIndex: '',
        key: 'rowIndex',
        width: 60,
        align: 'center',
        customRender: function customRender(t, r, index) {
          return parseInt(index) + 1;
        }
      }, {
        dataIndex: 'userId_userName',
        colName: 'userId_userName',
        title: '申请人',
        align: 'center',
        sorter: false
      },
      /*{
        dataIndex: 'deptId_departName',
        colName: 'deptId_departName',
        title: '申请科室',
        align: 'center',
        sorter: false
      },*/
      // {
      //   dataIndex: 'departName',
      //   colName: 'departName',
      //   title: '申请科室',
      //   align: 'center',
      //   sorter: false
      // },
      {
        dataIndex: 'sendNumber',
        colName: 'send_number',
        title: '发文字号',
        align: 'center',
        sorter: false
      }, {
        dataIndex: 'title',
        colName: 'title',
        title: '标题',
        align: 'center',
        sorter: false
      }, {
        dataIndex: 'documentType_dictText',
        colName: 'document_type',
        title: '公文类型',
        align: 'center',
        sorter: false
      }, {
        dataIndex: 'level_dictText',
        colName: 'level',
        title: '文件密级',
        align: 'center',
        sorter: false
      }, {
        dataIndex: 'degree_dictText',
        colName: 'degree',
        title: '紧急程度',
        align: 'center',
        sorter: false
      }, {
        dataIndex: 'content',
        colName: 'content',
        title: '内容',
        align: 'center',
        sorter: false
      }, // {
      //   dataIndex: 'startTime',
      //   colName: 'start_time',
      //   title: '开始时间',
      //   align: 'center',
      //   sorter: true
      // },
      // {
      //   dataIndex: 'endTime',
      //   colName: 'end_time',
      //   title: '结束时间',
      //   align: 'center',
      //   sorter: true
      // },
      {
        dataIndex: 'currentStatus',
        colName: 'currentStatus',
        title: '当前审批状态',
        align: 'center',
        scopedSlots: {
          customRender: 'currentStatus'
        }
      }, {
        title: '操作',
        dataIndex: 'action',
        align: 'center',
        width: 140,
        scopedSlots: {
          customRender: 'action'
        }
      }]
    };
  },
  created: function created() {
    this.loadTree();
  },
  methods: {
    modalFormOk: function modalFormOk() {
      this.searchReset();
    },
    loadTree: function loadTree() {
      var _this = this;

      var that = this;
      that.deptTree = [];
      that.userTree = []; // 用户

      queryUserTreeList().then(function (res) {
        if (res.success) {
          for (var i = 0; i < res.result.length; i++) {
            var temp = res.result[i];
            that.userTree.push(temp);
          }

          _this.loading = false;
        }
      }); // 部门

      queryDepartTreeList().then(function (res) {
        if (res.success) {
          for (var i = 0; i < res.result.length; i++) {
            var temp = res.result[i];
            that.deptTree.push(temp);
          }

          _this.loading = false;
        }
      });
    } // onDateStartTime: function(value, dateArray) {
    //   this.queryParam.startTimeStart = dateArray[0]
    //   this.queryParam.startTimeEnd = dateArray[1]
    // },
    // onDateEndTime: function(value, dateArray) {
    //   this.queryParam.endTimeStart = dateArray[0]
    //   this.queryParam.endTimeEnd = dateArray[1]
    // }

  }
};